import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { gray, green, orange, red } from "../../../utils/theme/colors.ts";

export const statusColors: any = {
  Folder: {
    in_progress: gray,
    completed: green,
    pending_upload: gray,
    pending_review: orange,
    valid: green,
    invalid: red,
  },
  Requirement: {
    pending_upload: gray,
    pending_review: orange,
    valid: green,
    invalid: red,
  },
  Subfolder: {
    pending_upload: gray,
    pending_review: orange,
    valid: green,
    invalid: red,
  },
  DocumentFile: {
    pending_upload: gray,
    pending_review: orange,
    valid: green,
    invalid: red,
  },
};

export const statusMapping: any = {
  Folder: {
    in_progress: {
      text: "En progreso",
      icon: <ClockCircleOutlined />,
    },
    completed: {
      text: "Completado",
      icon: <CheckCircleOutlined />,
    },
    pending_upload: {
      text: "Pendiente",
      icon: <ExclamationCircleOutlined />,
    },
    pending_review: {
      text: "En revisión",
      icon: <ClockCircleOutlined />,
    },
    valid: {
      text: "Válido",
      icon: <CheckCircleOutlined />,
    },
    invalid: {
      text: "Inválido",
      icon: <CloseCircleOutlined />,
    },
  },
  Requirement: {
    pending_upload: {
      text: "Pendiente",
      icon: <ExclamationCircleOutlined />,
    },
    pending_review: {
      text: "En revisión",
      icon: <ClockCircleOutlined />,
    },
    valid: {
      text: "Válido",
      icon: <CheckCircleOutlined />,
    },
    invalid: {
      text: "Inválido",
      icon: <CloseCircleOutlined />,
    },
  },
  Subfolder: {
    pending_upload: {
      text: "Pendiente",
      icon: <ExclamationCircleOutlined />,
    },
    pending_review: {
      text: "En revisión",
      icon: <ClockCircleOutlined />,
    },
    valid: {
      text: "Válido",
      icon: <CheckCircleOutlined />,
    },
    invalid: {
      text: "Inválido",
      icon: <CloseCircleOutlined />,
    },
  },
  DocumentFile: {
    pending_upload: {
      text: "Pendiente",
      icon: <ExclamationCircleOutlined />,
    },
    pending_review: {
      text: "En revisión",
      icon: <ClockCircleOutlined />,
    },
    valid: {
      text: "Válido",
      icon: <CheckCircleOutlined />,
    },
    invalid: {
      text: "Inválido",
      icon: <CloseCircleOutlined />,
    },
  },
};
